// dpc-app-invite.js — Banner que invita a usuarios de la tienda regular a abrir/instalar la app DPCL.
// Subir como theme asset en Shopify y cargar desde theme.liquid con:
//   <script src="{{ 'dpc-app-invite.js' | asset_url }}" defer></script>

(function () {
  'use strict';

  const APP_URL = '/pages/drinking-partners-app';
  const DISMISS_KEY = 'dpc_app_invite_dismissed_v1';
  const DISMISS_DAYS = 7;
  const INSTALLED_KEY = 'dpc_app_installed_v1'; // mismo flag que la app pone cuando se instala

  // ============================================================
  // Condiciones de NO mostrar
  // ============================================================

  // 1. Ya estás DENTRO de la app
  if (location.pathname === APP_URL || location.pathname.startsWith(APP_URL + '/')) return;

  // 2. Ya tienes la app instalada como PWA standalone (la abriste desde el ícono del home)
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return;

  // 3. Lo descartaste recientemente
  try {
    const dismissedAt = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
    if (Date.now() - dismissedAt < DISMISS_DAYS * 24 * 60 * 60 * 1000) return;
  } catch (e) {}

  // 4. Bots / crawlers — no inflar UI
  if (/bot|crawler|spider|crawling/i.test(navigator.userAgent)) return;

  // ============================================================
  // Detectar plataforma
  // ============================================================
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/i.test(ua);
  const isMobile = isIOS || isAndroid;

  // ¿La instalaron antes? (la app marca dpc_app_installed_v1=1 al abrirse standalone)
  let yaInstalada = false;
  try { yaInstalada = localStorage.getItem(INSTALLED_KEY) === '1'; } catch (e) {}

  // ============================================================
  // Estilos (inline para no depender del theme)
  // ============================================================
  const style = document.createElement('style');
  style.id = 'dpc-app-invite-style';
  style.textContent = `
    @keyframes dpc-inv-up { from { transform:translateY(110%); opacity:0; } to { transform:translateY(0); opacity:1; } }
    @keyframes dpc-inv-down { from { transform:translateY(0); opacity:1; } to { transform:translateY(110%); opacity:0; } }
    @keyframes dpc-inv-tag-pulse {
      0%   { transform:scale(1);    box-shadow:0 0 0 0 rgba(255,145,77,0.7); }
      50%  { transform:scale(1.08); box-shadow:0 0 10px 4px rgba(255,145,77,0.55); }
      100% { transform:scale(1);    box-shadow:0 0 0 8px rgba(255,145,77,0); }
    }
    @keyframes dpc-inv-border-shine {
      0%        { transform:translateX(-100%); }
      30%, 100% { transform:translateX(400%); }
    }
    @keyframes dpc-inv-attention {
      0%, 92%, 100% { transform:translateY(0) translateX(0); }
      94%           { transform:translateY(-3px) translateX(0); }
      96%           { transform:translateY(0) translateX(-2px); }
      98%           { transform:translateY(0) translateX(2px); }
    }
    .dpc-inv {
      position:fixed; bottom:0; left:0; right:0; z-index:2147483640;
      background:#1a1a1a;
      border-top:2px solid #FF914D;
      padding:12px 14px calc(12px + env(safe-area-inset-bottom,0px));
      display:flex; align-items:center; gap:12px;
      animation:dpc-inv-up 0.35s ease-out;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
      /* En móvil: sin overflow:hidden para que el halo del pulso no se clipee.
         El banner ocupa todo el ancho de pantalla, así que el shine que se sale por
         los lados queda off-screen naturalmente. */
    }
    .dpc-inv.dpc-inv--closing { animation:dpc-inv-down 0.25s ease-in forwards; }
    /* Brillo sutil que recorre el borde naranja superior cada ~6s */
    .dpc-inv::before {
      content:""; position:absolute; top:-2px; left:0; height:2px; width:30%;
      background:linear-gradient(90deg, transparent, #fff, transparent);
      opacity:0.65;
      animation:dpc-inv-border-shine 6s ease-in-out infinite;
      animation-delay:2s;
      pointer-events:none;
    }

    .dpc-inv__icon {
      width:44px; height:44px; border-radius:8px; flex-shrink:0;
      object-fit:cover; display:block;
    }

    .dpc-inv__txt { flex:1; min-width:0; color:#fff; }
    .dpc-inv__title {
      font-size:14px; font-weight:600; line-height:1.3; margin-bottom:3px;
      white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
    }
    .dpc-inv__sub {
      font-size:12px; color:#aaa; line-height:1.35; font-weight:400;
      white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
      display:flex; align-items:center; gap:8px;
    }
    .dpc-inv__sub-tag {
      display:inline-block; background:#FF914D; color:#fff;
      font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:4px;
      letter-spacing:0.3px; flex-shrink:0;
      transform-origin:center;
      animation:dpc-inv-tag-pulse 2s ease-out infinite;
      animation-delay:1.5s;
    }
    @media (min-width:768px) {
      .dpc-inv__title { white-space:normal; overflow:visible; text-overflow:clip; font-size:14.5px; }
      .dpc-inv__sub   { white-space:normal; overflow:visible; text-overflow:clip; font-size:12.5px; }
    }

    .dpc-inv__btn {
      background:#FF914D; border:none; color:#fff;
      font-size:13px; font-weight:600; padding:10px 16px;
      border-radius:6px; cursor:pointer; flex-shrink:0; text-decoration:none;
      display:inline-flex; align-items:center; gap:4px;
      letter-spacing:0.2px;
      transition:background 0.15s ease;
    }
    .dpc-inv__btn:hover { background:#ff7e3d; }
    .dpc-inv__btn:active { transform:scale(0.97); }

    .dpc-inv__close {
      background:transparent; border:none; color:#888;
      font-size:22px; width:28px; height:28px;
      padding:0; cursor:pointer; line-height:1; flex-shrink:0;
      display:flex; align-items:center; justify-content:center;
      transition:color 0.15s ease;
    }
    .dpc-inv__close:hover { color:#fff; }

    @media (min-width:768px) {
      .dpc-inv {
        max-width:480px; left:auto; right:20px; bottom:20px;
        border-radius:8px;
        border:1px solid #2a2a2a;
        border-top:2px solid #FF914D;
        padding:16px 18px;
        align-items:center;
        gap:14px;
        overflow:hidden; /* desktop: contiene el shine dentro del card redondeado */
      }
    }
  `;
  document.head.appendChild(style);

  // ============================================================
  // Textos según contexto
  // La app es solo para móvil → en desktop SOLO mostramos QR, sin botón de abrir
  // ============================================================
  let title, sub, subTag, btnText;
  if (yaInstalada) {
    title = 'Abre tu app instalada';
    sub = 'Más rápido, recordatorios y pedidos guardados';
    subTag = null;
    btnText = 'Abrir';
  } else if (isMobile) {
    title = 'Llévate la app DPCL';
    sub = 'Reserva, recordatorios y descuento';
    subTag = '10% OFF';
    btnText = 'Probar';
  } else {
    title = 'Reserva más fácil desde la app';
    sub = 'Escanea el QR con tu celular';
    subTag = '10% OFF';
    btnText = null; // desktop: no hay botón, solo QR
  }

  // CSS extra para el QR (desktop)
  const styleQR = document.createElement('style');
  styleQR.textContent = `
    @keyframes dpc-qr-bounce {
      0%, 100% { transform:translateY(0); }
      50%      { transform:translateY(-3px); }
    }
    .dpc-inv__qr {
      width:80px; height:80px; border-radius:6px; flex-shrink:0;
      background:#fff; padding:6px; box-sizing:border-box;
      display:none; cursor:pointer; position:relative;
      transition:transform 0.15s ease;
    }
    .dpc-inv__qr:hover { transform:scale(1.04); }
    .dpc-inv__qr img { width:100%; height:100%; display:block; }

    @media (min-width:768px) {
      .dpc-inv__qr { display:flex; align-items:center; justify-content:center; }
    }
    /* Modal expandido del QR al hacer click */
    .dpc-qr-modal {
      position:fixed; inset:0; background:rgba(0,0,0,0.8); z-index:2147483641;
      display:flex; align-items:center; justify-content:center; padding:20px;
      animation:dpc-inv-up 0.2s ease-out;
    }
    .dpc-qr-modal__box {
      background:#fff;
      border-radius:10px; padding:28px 26px;
      max-width:320px; width:100%; text-align:center;
      box-shadow:0 16px 50px rgba(0,0,0,0.4);
    }
    .dpc-qr-modal__title { font-size:16px; font-weight:600; color:#1a1a1a; margin-bottom:6px; }
    .dpc-qr-modal__sub { font-size:13px; color:#666; margin-bottom:18px; line-height:1.45; }
    .dpc-qr-modal__img {
      width:240px; height:240px; margin:0 auto; display:block;
    }
    .dpc-qr-modal__close {
      margin-top:18px; background:#FF914D; color:#fff; border:none;
      font-size:13px; font-weight:600; padding:10px 22px; border-radius:6px; cursor:pointer;
    }
    .dpc-qr-modal__close:hover { background:#ff7e3d; }
  `;
  document.head.appendChild(styleQR);

  // URL absoluta del app para el QR
  const APP_FULL_URL = location.origin + APP_URL;
  // Servicio QR (qrserver.com es gratis y estable; alternativa: chart.googleapis.com)
  const QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(APP_FULL_URL)}&color=1a1a1a&bgcolor=ffffff&margin=2`;
  const QR_SRC_SMALL = `https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(APP_FULL_URL)}&color=1a1a1a&bgcolor=ffffff&margin=2`;

  // ============================================================
  // Crear y mostrar banner
  // ============================================================
  const banner = document.createElement('div');
  banner.className = 'dpc-inv';
  const showQR = !isMobile && !yaInstalada; // QR solo en desktop, no en móvil ni si ya instalada
  const showBtn = !!btnText; // botón "Abrir/Probar" solo si hay texto (móvil o instalada). Desktop sin botón.
  banner.innerHTML = `
    <img class="dpc-inv__icon" src="/cdn/shop/files/dpc-apple-touch-icon.png" alt="DPCL" onerror="this.style.display='none'">
    <div class="dpc-inv__txt">
      <div class="dpc-inv__title">${title}</div>
      <div class="dpc-inv__sub">
        ${subTag ? `<span class="dpc-inv__sub-tag">${subTag}</span>` : ''}
        <span>${sub}</span>
      </div>
    </div>
    ${showQR ? `
      <div class="dpc-inv__qr" id="dpc-inv-qr-trigger" title="Click para agrandar">
        <img src="${QR_SRC_SMALL}" alt="QR para abrir en celular">
      </div>
    ` : ''}
    ${showBtn ? `<a class="dpc-inv__btn" href="${APP_URL}">${btnText}</a>` : ''}
    <button class="dpc-inv__close" aria-label="Cerrar">×</button>
  `;

  setTimeout(() => {
    document.body.appendChild(banner);
    banner.querySelector('.dpc-inv__close').addEventListener('click', () => {
      banner.classList.add('dpc-inv--closing');
      setTimeout(() => banner.remove(), 300);
      try { localStorage.setItem(DISMISS_KEY, Date.now().toString()); } catch (e) {}
    });
    // Click en el QR chico → abre modal con QR grande
    const qrTrigger = banner.querySelector('#dpc-inv-qr-trigger');
    if (qrTrigger) {
      qrTrigger.addEventListener('click', () => {
        const modal = document.createElement('div');
        modal.className = 'dpc-qr-modal';
        modal.innerHTML = `
          <div class="dpc-qr-modal__box" onclick="event.stopPropagation()">
            <div class="dpc-qr-modal__title">Escanea para abrir en tu celular</div>
            <div class="dpc-qr-modal__sub">Apunta la cámara, toca el link e instala la app — 10% OFF al arrendar desde ahí</div>
            <img class="dpc-qr-modal__img" src="${QR_SRC}" alt="QR app DPCL">
            <button class="dpc-qr-modal__close">Cerrar</button>
          </div>
        `;
        modal.addEventListener('click', () => modal.remove());
        modal.querySelector('.dpc-qr-modal__close').addEventListener('click', () => modal.remove());
        document.body.appendChild(modal);
      });
    }
  }, 1500);
})();
